/* =========================================================
   REAL DEAL 3D PACKAGE CAROUSEL
   DPO FIELD 1007
   ORDER INDEPENDENT
   ========================================================= */

(function () {
  "use strict";

  const FIELD_SELECTOR = "#dynamic_option_id_1007";
  const LIST_SELECTOR = "#options-1007-list";
  const CARD_SELECTOR = ":scope > .field.choice";

  let resizeTimer = null;


  /* =======================================================
     BASIC HELPERS
     ======================================================= */

  function getField() {
    return document.querySelector(FIELD_SELECTOR);
  }

  function getList(field) {
    return field
      ? field.querySelector(LIST_SELECTOR)
      : null;
  }

  function getCards(list) {
    if (!list) return [];

    return Array.from(
      list.querySelectorAll(CARD_SELECTOR)
    );
  }

  function getRadio(card) {
    return card
      ? card.querySelector('input[type="radio"]')
      : null;
  }

  function getCardText(card) {
    return (card.textContent || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function getCheckedIndex(cards) {
    const index = cards.findIndex(function (card) {
      const radio = getRadio(card);

      return radio && radio.checked;
    });

    return index >= 0 ? index : 0;
  }

  function getActiveIndex(field) {
    const stored = parseInt(
      field.dataset.rdActivePackage,
      10
    );

    return Number.isInteger(stored)
      ? stored
      : 0;
  }

  function normalizeIndex(index, count) {
    if (!count) return 0;

    return (
      (index % count) +
      count
    ) % count;
  }


  /* =======================================================
     IDENTIFY PACKAGE TYPE
     NO nth-child DEPENDENCY
     ======================================================= */

function classifyPackages(cards) {

  cards.forEach(function (card) {

    card.classList.remove(
      "rd-package-basic",
      "rd-package-premium",
      "rd-package-ultra"
    );

    const text = getCardText(card);

    if (
      text.includes(
        "basic compliance trim"
      )
    ) {
      card.classList.add(
        "rd-package-basic"
      );
    }

    if (
      text.includes(
        "premium yard reset"
      )
    ) {
      card.classList.add(
        "rd-package-premium"
      );
    }

    if (
      text.includes(
        "ultra yard reset"
      )
    ) {
      card.classList.add(
        "rd-package-ultra"
      );
    }

  });

}


  /* =======================================================
     MOST POPULAR
     MANUAL CLASS WINS
     OTHERWISE PREMIUM IS AUTOMATIC
     ======================================================= */

  function markMostPopular(cards) {

    const manual =
      cards.find(function (card) {

        return (
          card.classList.contains(
            "rd-most-popular"
          ) &&
          card.dataset.rdAutoPopular !== "1"
        );

      });

    cards.forEach(function (card) {

      if (
        card.dataset.rdAutoPopular === "1"
      ) {
        card.classList.remove(
          "rd-most-popular"
        );

        delete card.dataset.rdAutoPopular;
      }

    });

    if (manual) {
      manual.classList.add(
        "rd-most-popular"
      );

      return;
    }

    const premium =
      cards.find(function (card) {

        return card.classList.contains(
          "rd-package-premium"
        );

      });

    if (premium) {

      premium.classList.add(
        "rd-most-popular"
      );

      premium.dataset.rdAutoPopular =
        "1";
    }

  }


  /* =======================================================
     BENEFIT COPY
     ORDER INDEPENDENT
     ======================================================= */

  function getOrCreateBenefits(card) {

    let benefits =
      card.querySelector(
        ".rd-package-benefits"
      );

    if (!benefits) {

      benefits =
        document.createElement("div");

      benefits.className =
        "rd-package-benefits";

      card.appendChild(
        benefits
      );
    }

    return benefits;
  }

  function updatePackageBenefits(cards) {

    const premiumHTML =
      "<strong>FULL WEED REMOVAL.</strong>" +
      "<span>Regrowth usually takes 6 to 12 months</span>" +
      "<span>Removal down to bare dirt</span>" +
      "<span>Cracks, curbs, edges and tight areas included</span>" +
      "<span>Extra attention to detail</span>" +
      "<span>Best finished appearance</span>";

    const basicHTML =
      "<strong>TRIM. NOT REMOVAL.</strong>" +
      "<span>Regrowth usually in 1 to 3 months</span>" +
      "<span>Great for city compliance</span>" +
      "<span>Keeps weeds controlled</span>" +
      "<span>Lower cost maintenance option</span>";

    cards.forEach(function (card) {

      const benefits =
        getOrCreateBenefits(card);

      let type = "";
      let html = "";

      if (
        card.classList.contains(
          "rd-package-premium"
        )
      ) {
        type = "premium";
        html = premiumHTML;
      } else if (
        card.classList.contains(
          "rd-package-basic"
        )
      ) {
        type = "basic";
        html = basicHTML;
      } else if (
        card.classList.contains(
          "rd-package-ultra"
        )
      ) {
        type = "ultra";
        html = premiumHTML;
      }

      if (!type) {
        return;
      }

      if (
        benefits.dataset.rdContentType !==
        type
      ) {

        benefits.innerHTML =
          html;

        benefits.dataset.rdContentType =
          type;

      }

    });

  }


  /* =======================================================
     DPO SELECTION
     ======================================================= */

  function selectCard(card) {

    const radio =
      getRadio(card);

    if (!radio) return;

    if (!radio.checked) {

      radio.checked = true;

      radio.dispatchEvent(
        new Event(
          "input",
          {
            bubbles: true
          }
        )
      );

      radio.dispatchEvent(
        new Event(
          "change",
          {
            bubbles: true
          }
        )
      );

    }

  }


  /* =======================================================
     CONTROLS
     ======================================================= */

  function createArrow(direction) {

    const button =
      document.createElement(
        "button"
      );

    button.type =
      "button";

    button.className =
      "rd-package-arrow " +
      "rd-package-arrow-" +
      direction;

    button.setAttribute(
      "aria-label",
      direction === "left"
        ? "Previous package"
        : "Next package"
    );

    button.innerHTML =
      direction === "left"
        ? "‹"
        : "›";

    return button;
  }

  function createDots() {

    const dots =
      document.createElement(
        "div"
      );

    dots.className =
      "rd-package-dots";

    return dots;
  }

  function buildDots(
    dots,
    cards
  ) {

    const existing =
      Array.from(
        dots.querySelectorAll(
          ".rd-package-dot"
        )
      );

    if (
      existing.length ===
      cards.length
    ) {

      existing.forEach(
        function (
          dot,
          index
        ) {

          dot.dataset.index =
            String(index);

          dot.setAttribute(
            "aria-label",
            "Show package " +
              (index + 1)
          );

        }
      );

      return;
    }

    dots.innerHTML = "";

    cards.forEach(
      function (
        _,
        index
      ) {

        const dot =
          document.createElement(
            "button"
          );

        dot.type =
          "button";

        dot.className =
          "rd-package-dot";

        dot.dataset.index =
          String(index);

        dot.setAttribute(
          "aria-label",
          "Show package " +
            (index + 1)
        );

        dots.appendChild(
          dot
        );

      }
    );

  }



  /* =======================================================
     DYNAMIC STAGE HEIGHT
     REMOVES HUGE EMPTY CARD SPACE
     ======================================================= */

  function syncStageHeight(
    list,
    cards
  ) {

    if (!list || !cards.length) {
      return;
    }

    requestAnimationFrame(
      function () {

        let tallest = 0;

        cards.forEach(
          function (card) {

            tallest =
              Math.max(
                tallest,
                card.offsetHeight
              );

          }
        );

        if (tallest > 0) {

          list.style.height =
            (tallest + 58) +
            "px";

        }

      }
    );

  }


  /* =======================================================
     3D POSITIONING
     ======================================================= */

  function apply3DState(
    field,
    list,
    cards,
    dots,
    activeIndex,
    shouldSelect
  ) {

    const count =
      cards.length;

    if (!count) return;

    activeIndex =
      normalizeIndex(
        activeIndex,
        count
      );

    field.dataset.rdActivePackage =
      String(activeIndex);

    cards.forEach(
      function (
        card,
        index
      ) {

        card.classList.remove(
          "rd-package-active",
          "rd-package-prev",
          "rd-package-next",
          "rd-package-far-prev",
          "rd-package-far-next"
        );

        let distance =
          index -
          activeIndex;

        if (
          distance >
          count / 2
        ) {
          distance -=
            count;
        }

        if (
          distance <
          -count / 2
        ) {
          distance +=
            count;
        }

        if (
          distance === 0
        ) {

          card.classList.add(
            "rd-package-active"
          );

        } else if (
          distance === -1
        ) {

          card.classList.add(
            "rd-package-prev"
          );

        } else if (
          distance === 1
        ) {

          card.classList.add(
            "rd-package-next"
          );

        } else if (
          distance < -1
        ) {

          card.classList.add(
            "rd-package-far-prev"
          );

        } else {

          card.classList.add(
            "rd-package-far-next"
          );

        }

        card.setAttribute(
          "aria-current",
          index === activeIndex
            ? "true"
            : "false"
        );

      }
    );

    if (dots) {

      Array.from(
        dots.children
      ).forEach(
        function (
          dot,
          index
        ) {

          dot.classList.toggle(
            "rd-package-dot-active",
            index === activeIndex
          );

        }
      );

    }

    if (
      shouldSelect !== false
    ) {

      selectCard(
        cards[
          activeIndex
        ]
      );

    }

    syncStageHeight(
      list,
      cards
    );

  }


  /* =======================================================
     SPOTLIGHT MODE
     ======================================================= */

  function setupSpotlight(
    field
  ) {

    if (
      field.dataset.rdSpotlightBound ===
      "1"
    ) {
      return;
    }

    field.dataset.rdSpotlightBound =
      "1";

    if (
      !(
        "IntersectionObserver"
        in window
      )
    ) {
      return;
    }

    const observer =
      new IntersectionObserver(
        function (entries) {

          entries.forEach(
            function (entry) {

              field.classList.toggle(
                "rd-package-spotlight",
                entry.isIntersecting &&
                entry.intersectionRatio >
                  0.35
              );

            }
          );

        },
        {
          threshold: [
            0,
            0.2,
            0.35,
            0.5,
            0.75
          ]
        }
      );

    observer.observe(
      field
    );

  }


  /* =======================================================
     INITIALIZE
     ======================================================= */

  function initializeCarousel() {

    const field =
      getField();

    if (!field) {
      return false;
    }

    const list =
      getList(field);

    if (!list) {
      return false;
    }

    let cards =
      getCards(list);

    if (!cards.length) {
      return false;
    }

    field.classList.add(
      "rd-package-carousel-ready"
    );

    classifyPackages(
      cards
    );

    markMostPopular(
      cards
    );

    updatePackageBenefits(
      cards
    );

    setupSpotlight(
      field
    );


    /* arrows */

    let leftArrow =
      field.querySelector(
        ".rd-package-arrow-left"
      );

    let rightArrow =
      field.querySelector(
        ".rd-package-arrow-right"
      );

    if (!leftArrow) {

      leftArrow =
        createArrow(
          "left"
        );

      field.appendChild(
        leftArrow
      );

    }

    if (!rightArrow) {

      rightArrow =
        createArrow(
          "right"
        );

      field.appendChild(
        rightArrow
      );

    }


    /* dots */

    let dots =
      field.querySelector(
        ".rd-package-dots"
      );

    if (!dots) {

      dots =
        createDots();

      list.insertAdjacentElement(
        "afterend",
        dots
      );

    }

    buildDots(
      dots,
      cards
    );


    /* cards */

    cards.forEach(
      function (
        card,
        index
      ) {

        if (
          card.dataset.rd3dBound ===
          "1"
        ) {
          return;
        }

        card.dataset.rd3dBound =
          "1";

        card.addEventListener(
          "click",
          function (event) {

            cards =
              getCards(
                list
              );

            dots =
              field.querySelector(
                ".rd-package-dots"
              );

            apply3DState(
              field,
              list,
              cards,
              dots,
              index,
              true
            );

          }
        );

      }
    );


    /* controls */

    if (
      field.dataset.rd3dControlsBound !==
      "1"
    ) {

      field.dataset.rd3dControlsBound =
        "1";


      leftArrow.addEventListener(
        "click",
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          cards =
            getCards(
              list
            );

          apply3DState(
            field,
            list,
            cards,
            dots,
            getActiveIndex(
              field
            ) - 1,
            true
          );

        }
      );


      rightArrow.addEventListener(
        "click",
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          cards =
            getCards(
              list
            );

          apply3DState(
            field,
            list,
            cards,
            dots,
            getActiveIndex(
              field
            ) + 1,
            true
          );

        }
      );


      dots.addEventListener(
        "click",
        function (event) {

          const dot =
            event.target.closest(
              ".rd-package-dot"
            );

          if (!dot) {
            return;
          }

          cards =
            getCards(
              list
            );

          apply3DState(
            field,
            list,
            cards,
            dots,
            parseInt(
              dot.dataset.index,
              10
            ),
            true
          );

        }
      );


      /* mobile swipe
         Horizontal gesture locks to carousel.
         Vertical gesture remains normal page scroll.
      */

      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      let horizontalGesture = false;

      list.addEventListener(
        "touchstart",
        function (event) {

          if (
            event.target.closest(
              "button"
            )
          ) {
            return;
          }

          const touch =
            event.touches[0];

          touchStartX =
            touch.clientX;

          touchStartY =
            touch.clientY;

          touchEndX =
            touchStartX;

          touchEndY =
            touchStartY;

          horizontalGesture =
            false;

        },
        {
          passive: true
        }
      );

      list.addEventListener(
        "touchmove",
        function (event) {

          if (
            event.target.closest(
              "button"
            )
          ) {
            return;
          }

          const touch =
            event.touches[0];

          touchEndX =
            touch.clientX;

          touchEndY =
            touch.clientY;

          const dx =
            touchEndX -
            touchStartX;

          const dy =
            touchEndY -
            touchStartY;

          if (
            !horizontalGesture &&
            Math.abs(dx) > 8 &&
            Math.abs(dx) >
              Math.abs(dy) * 1.1
          ) {
            horizontalGesture =
              true;
          }

          if (
            horizontalGesture
          ) {
            event.preventDefault();
          }

        },
        {
          passive: false
        }
      );

      list.addEventListener(
        "touchend",
        function (event) {

          if (
            event.target.closest(
              "button"
            )
          ) {
            return;
          }

          if (
            !horizontalGesture
          ) {
            return;
          }

          const dx =
            touchEndX -
            touchStartX;

          const dy =
            touchEndY -
            touchStartY;

          if (
            Math.abs(dx) < 30 ||
            Math.abs(dx) <=
              Math.abs(dy)
          ) {
            return;
          }

          cards =
            getCards(
              list
            );

          apply3DState(
            field,
            list,
            cards,
            dots,
            dx < 0
              ? getActiveIndex(
                  field
                ) + 1
              : getActiveIndex(
                  field
                ) - 1,
            true
          );

        },
        {
          passive: true
        }
      );


      /* external DPO change */

      document.addEventListener(
        "change",
        function (event) {

          const radio =
            event.target.closest(
              FIELD_SELECTOR +
              ' input[type="radio"]'
            );

          if (!radio) {
            return;
          }

          cards =
            getCards(
              list
            );

          const index =
            cards.findIndex(
              function (card) {

                return (
                  getRadio(card) ===
                  radio
                );

              }
            );

          if (
            index < 0
          ) {
            return;
          }

          apply3DState(
            field,
            list,
            cards,
            dots,
            index,
            false
          );

        }
      );

    }


    /* initial position */

    const startingIndex =
      getCheckedIndex(
        cards
      );

    apply3DState(
      field,
      list,
      cards,
      dots,
      startingIndex,
      false
    );

    return true;
  }


  /* =======================================================
     WATCH DPO REBUILDS
     ======================================================= */

  function startObserver() {

    const observer =
      new MutationObserver(
        function () {

          clearTimeout(
            observer._rdTimer
          );

          observer._rdTimer =
            setTimeout(
              initializeCarousel,
              100
            );

        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /* =======================================================
     START
     ======================================================= */

  function start() {

    initializeCarousel();
    startObserver();

    window.addEventListener(
      "resize",
      function () {

        clearTimeout(
          resizeTimer
        );

        resizeTimer =
          setTimeout(
            initializeCarousel,
            150
          );

      }
    );

  }

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      start
    );

  } else {

    start();

  }

})();